import { render, staticRenderFns } from "./ObjectDataChangeForm.vue?vue&type=template&id=4afd8a5a&"
import script from "./ObjectDataChangeForm.vue?vue&type=script&lang=js&"
export * from "./ObjectDataChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports